<template>
    <v-container class="pa-0 pb-0">
        <v-row>
            <v-col cols="12" md="12" class="pt-0">
                <v-text-field
                    v-model="searchText"
                    :label="localize('searchFavoriteProduct')"
                    dense
                    outlined
                    hide-details
                    @keyup="startSearchFavorites"
                >
                    <fa slot="append" :icon="['fal', 'search']" class="fa-lg" />
                </v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
    name: 'SearchFavorites',
    props: {},
    data() {
        return{
            searchText: undefined,
        }
    },
    computed: {
        ...mapGetters({favorites: 'favorites/fetchAvailableFavList',})
    },
    methods: {
        startSearchFavorites(){
            this.$emit('startLoading')
            this.searchFavorites()
        },
        searchFavorites: _.debounce(function() {
            let search = this.searchText.toLowerCase()
            const locale = this.$i18n.locale
            let filteredFavorites = this.favorites.filter(element => {
                let pn = element.pn.toLowerCase()
                let name = element[`name_${locale}`].toLowerCase()
                return pn.includes(search) || name.includes(search)
            })
            this.$emit('searchFavorites', filteredFavorites)
        }, 700)
    }
}
</script>
